import React, { useEffect, useState } from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import NotificationManager from "react-notifications/lib/NotificationManager";
import DropDownKendoRct from "../../control-components/drop-down/drop-down";
import { fileDocumentService } from "../../services/fileDocumentTemplateService";
import ApiUrls from "../../helper/api-urls";
import ApiHelper from "../../helper/api-helper";
import Loader from "../../control-components/loader/loader";
import InputKendoRct from "../../control-components/input/input";
import { Switch } from "@progress/kendo-react-inputs";
import API_URLS from "../../helper/api-urls";
import { useDispatch } from "react-redux";
import { Tooltip } from "@progress/kendo-react-tooltip";

const TemplateSettings = ({
    onClose,
    isSelectedId,
    getAllDocumentTemplates,
    isHtml,
    regionId,
    clinicId
}) => {
    const dispatch = useDispatch()
    const [settingError, setSettingError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [timeRecording, setTimeRecording] = useState([]);
    const [placeService, setPlaceService] = useState([]);
    const [fields, setFields] = useState({
      posTypeId: "",
      canAddNextAppt: false,
      timeRecordingMethodId: "",
      canApplyClientSig: false,
      showServiceControl: false,
      showClientProgress: false,
      showTreatmentPlan: false,
      showSiteOfService: false,
      showClientDiags: false,
      showFileAttachment: false,
      showVisitType: false,
      showAddGoalObjInt: false,
      showAddDiagnosis: false,
      showAddDemographics: false,
      showAuths: false,
      showRiskAssessment: false,
      staffSignatureNotRequired: false,
      bypassCompliance: false,
      clientFillable: false
    });
    const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  
    useEffect(() => {
      getTimeRecordingMethod();
      getDocumentTemplatePrefById();
      getPlaceOfService();
    }, []);
  
    const getTimeRecordingMethod = () => {
      setLoading(true);
      try {
        ApiHelper.getRequest(API_URLS.GET_TIME_RECORDING_METHODS).then(
          (response) => {
            const data = response.resultData;
            setTimeRecording(data);
            setLoading(false);
          }
        );
      } catch (error) {
        // renderErrors(error);
      }
    };
  
    const getPlaceOfService = () => {
      setLoading(true);
      try {
        ApiHelper.getRequest(API_URLS.GET_ALL_PLACE_OF_SERVICETYPE).then(
          (response) => {
            const data = response.resultData;
            setPlaceService(data);
            setLoading(false);
          }
        );
      } catch (error) {
        // renderErrors(error);
      }
    };
  
    const getDocumentTemplatePrefById = () => {
      setLoading(true);
      try {
        const data = {
          regionId: regionId,
          templateId: isSelectedId,
          clinicId: clinicId
        }
        const queryString = new URLSearchParams(data).toString();
          ApiHelper.getRequest(`${API_URLS.GET_DOCUMENT_TEMPLATE_PREFS_BY_TEMPLATE_ID}?${queryString}`).then((response) => {
          setLoading(false);
          const data = response.resultData;
          const posTypeId = {
            id: data.posTypeId,
            name: data.posTypeName
          };
          const timeRecordingMethod = {
            id: data.timeRecordingMethodId,
            name: data.timeRecordingMethod,
          };
          setFields({
            posTypeId: posTypeId,
            // canAddNextAppt: data.canAddNextAppt,
            timeRecordingMethodId: timeRecordingMethod,
            canApplyClientSig: data.canApplyClientSig,
            showClientProgress: data.showClientProgress,
            showServiceControl: data.showServiceControl,
            showTreatmentPlan: data.showTreatmentPlan,
            showSiteOfService: data.showSiteOfService,
            showClientDiags: data.showClientDiags,
            showVisitType: data.showVisitType,
            showFileAttachment: data.showFileAttachment,
            showAddGoalObjInt: data.showAddGoalObjInt,
            showAddDiagnosis: data.showAddDiagnosis,
            showAddDemographics: data.showAddDemographics,
            showAuths: data.showAuths,
            showRiskAssessment: data?.showRiskAssessment,
            showEbpCode:data?.showEbpCode,
            staffSignatureNotRequired: data.staffSignatureNotRequired,
            bypassCompliance: data?.bypassCompliance,
            clientFillable: data?.clientFillable
          });
        });
      } catch (error) {
        // renderErrors(error);
      }
    };
  
    const handleChange = (e) => {
      const name = e.target.name;
      const value = e.target.value;
      if(name==='clientFillable' &&  value === true){
        setFields({
          ...fields,
          canApplyClientSig: true,
          clientFillable:true,
        });
      }
      else if (name === "staffSignatureNotRequired" && value === true) {
        setShowConfirmationDialog(true);
      }
      else {
        setFields({
          ...fields,
          [name]: value,
        });
      }
    };
  
    const saveTask = async () => {
      setLoading(true);
      const data = {
        templateId: isSelectedId,
        posTypeId: fields.posTypeId.id ? fields.posTypeId.id : 1,
        // canAddNextAppt: fields.canAddNextAppt,
        timeRecordingMethodId: fields.timeRecordingMethodId.id
          ? fields.timeRecordingMethodId.id
          : 1,
        canApplyClientSig: fields.canApplyClientSig,
        showClientProgress: fields.showClientProgress,
        showServiceControl: fields.showServiceControl,
        showTreatmentPlan: fields.showTreatmentPlan,
        showSiteOfService: fields.showSiteOfService,
        showClientDiags: fields.showClientDiags,
        showFileAttachment: fields.showFileAttachment,
        showVisitType: fields.showVisitType,
        showAddGoalObjInt: fields.showAddGoalObjInt,
        showAddDiagnosis: fields.showAddDiagnosis,
        showAddDemographics: fields.showAddDemographics,
        showAuths: fields.showAuths,
        showRiskAssessment: fields?.showRiskAssessment,
        staffSignatureNotRequired: fields.staffSignatureNotRequired,
        bypassCompliance: fields.bypassCompliance,
        showEbpCode:fields?.showEbpCode,
        regionId: regionId,
        clinicId: clinicId,
        clientFillable:fields?.clientFillable
      };
  
  
  
  
      await ApiHelper.postRequest(API_URLS.INSERT_OR_UPDATE_DOCUMENT_TEMPLATE_PREF, data)
        .then((result) => {
          setLoading(false);
          onClose({ added: true });
          getAllDocumentTemplates();
          NotificationManager.success('Document Template updated successfully ')
        })
        .catch((error) => {
  
          setLoading(false);
        //   renderErrors(error);
        });
    };
  
    const handleSubmit = () => {
    //   dispatch(saveTemplateSetting(fields))
      setSettingError(true);
      saveTask();
  
    };
  
    const handleCloseConfirmationDialog = () => {
      setShowConfirmationDialog(false);
    }
  
    const handleYesOperation = () => {
      setFields({
        ...fields,
        staffSignatureNotRequired: true,
      });
      setShowConfirmationDialog(false);
    }
  

    return (
        <div>
            {loading == true && <Loader />}
            <Dialog
                onClose={onClose}
                title={"Template Settings"}
                className="small-dailog"
                width={"70%"} height={"70%"}
            >


{loading == true && <Loader />}
      <div className="column mt-3 ">

        <div className="col-md-12 col-lg-12 col-12 mb-3">
          <DropDownKendoRct
            validityStyles={settingError}
            data={placeService}
            onChange={handleChange}
            value={fields.posTypeId}
            textField="name"
            label="Place Of Service"
            dataItemKey="id"
            name="posTypeId"
            defaultValue={"Not Required"}
          />
        </div>

        <div className="col-md-12 col-lg-12 col-12 mb-3">
          <DropDownKendoRct
            validityStyles={settingError}
            data={timeRecording}
            onChange={handleChange}
            value={fields.timeRecordingMethodId}
            textField="name"
            label="Time Recording Method"
            dataItemKey="id"
            name="timeRecordingMethodId"
          />
        </div>
        <div className="row m-0">
          <div className="col-md-6 col-lg-6 col-6 mb-3">
            <Switch
              value={fields.canApplyClientSig}
              name={"canApplyClientSig"}
              onChange={handleChange}
              checked={fields.canApplyClientSig}
            />

            <span className="switch-title-text ml-2  fw-400 f-16 ">
              Can Apply Client Signature
            </span>
          </div>

          <div className="col-md-6 col-lg-6 col-6 mb-3 d-flex align-items-center">
            <Switch
              value={fields.clientFillable}
              name={"clientFillable"}
              onChange={handleChange}
              checked={fields.clientFillable}
            />

            <span className="switch-title-text ml-2 fw-400 f-16 d-flex align-items-center">
              Have Client Input Fields
              <Tooltip anchorElement="target" position="right" className="ml-2" style={{zIndex:"99999"}}>
                <i
                  style={{ cursor: 'pointer' }}
                  title={'By enabling Have Client Input Fields, Can Apply Client Signature will be automatically Selected.'}
                  className="fa fa-info-circle ml-2"
                />
              </Tooltip>
            </span>
          </div>

          <div className="col-md-6 col-lg-6 col-6 mb-3">
            <Switch
              value={fields.showServiceControl}
              name={"showServiceControl"}
              onChange={handleChange}
              checked={fields.showServiceControl}
            />

            <span className="switch-title-text ml-2  fw-400 f-16 ">
              Show Service Control
            </span>
          </div>
          <div className="col-md-6 col-lg-6 col-6 mb-3">
            <Switch
              value={fields.showClientProgress}
              name={"showClientProgress"}
              onChange={handleChange}
              checked={fields.showClientProgress}
            />

            <span className="switch-title-text ml-2  fw-400 f-16 ">
              Show Client Progress
            </span>
          </div>
          <div className="col-md-6 col-lg-6 col-6 mb-3">
            <Switch
              value={fields.showTreatmentPlan}
              name={"showTreatmentPlan"}
              onChange={handleChange}
              checked={fields.showTreatmentPlan}
            />

            <span className="switch-title-text ml-2  fw-400 f-16 ">
              Show Treatment Plan
            </span>
          </div>
          <div className="col-md-6 col-lg-6 col-6 mb-3">
            <Switch
              value={fields.showSiteOfService}
              name={"showSiteOfService"}
              onChange={handleChange}
              checked={fields.showSiteOfService}
            />

            <span className="switch-title-text ml-2  fw-400 f-16 ">
              Show Site of Service
            </span>
          </div>
          <div className="col-md-6 col-lg-6 col-6 mb-3">
            <Switch
              value={fields.showClientDiags}
              name={"showClientDiags"}
              onChange={handleChange}
              checked={fields.showClientDiags}
            />

            <span className="switch-title-text ml-2  fw-400 f-16 ">
              Show Client Diagnosis
            </span>
          </div>
          <div className="col-md-6 col-lg-6 col-6 mb-3">
            <Switch
              value={fields.showVisitType}
              name={"showVisitType"}
              onChange={handleChange}
              checked={fields.showVisitType}
            />

            <span className="switch-title-text ml-2  fw-400 f-16 ">
              Show Visit Type
            </span>
          </div>

          <div className="col-md-6 col-lg-6 col-6 mb-3">
            <Switch
              value={fields.showAuths}
              name={"showAuths"}
              onChange={handleChange}
              checked={fields.showAuths}
            />

            <span className="switch-title-text ml-2  fw-400 f-16 ">
              Show Authorizations
            </span>
          </div>

          <div className="col-md-6 col-lg-6 col-6 mb-3">
            <Switch
              value={fields.showFileAttachment}
              name={"showFileAttachment"}
              onChange={handleChange}
              checked={fields.showFileAttachment}
            />

            <span className="switch-title-text ml-2 fw-400 f-16 ">
              Show File Attachment
            </span>
          </div>


          <div className="col-md-6 col-lg-6 col-6 mb-3">
            <Switch
              value={fields.showAddGoalObjInt}
              name={"showAddGoalObjInt"}
              onChange={handleChange}
              checked={fields.showAddGoalObjInt}
            />

            <span className="switch-title-text ml-2 fw-400 f-16 ">
              Show Goals (Save to Client Profile)
            </span>
          </div>

          <div className="col-md-6 col-lg-6 col-6 mb-3">
            <Switch
              value={fields.showAddDiagnosis}
              name={"showAddDiagnosis"}
              onChange={handleChange}
              checked={fields.showAddDiagnosis}
            />

            <span className="switch-title-text ml-2 fw-400 f-16 ">
              Show Dx (Save to Client Profile)
            </span>
          </div>


          <div className="col-md-6 col-lg-6 col-6 mb-3">
            <Switch
              value={fields.showAddDemographics}
              name={"showAddDemographics"}
              onChange={handleChange}
              checked={fields.showAddDemographics}
            />

            <span className="switch-title-text ml-2 fw-400 f-16 ">
              Show Common Details
            </span>
          </div>
          <div className="col-md-6 col-lg-6 col-6 mb-3">
            <Switch
              value={fields.showRiskAssessment}
              name={"showRiskAssessment"}
              onChange={handleChange}
              checked={fields.showRiskAssessment}
            />

            <span className="switch-title-text ml-2 fw-400 f-16 ">
              Show Risk Assessment
            </span>
          </div>
          <div className="col-md-6 col-lg-6 col-6 mb-3">
            <Switch
              value={fields.staffSignatureNotRequired}
              name={"staffSignatureNotRequired"}
              onChange={handleChange}
              checked={fields.staffSignatureNotRequired}
            />

            <span className="switch-title-text ml-2 fw-400 f-16 ">
              Staff Signature Not Required
            </span>
          </div>

          <div className="col-md-6 col-lg-6 col-6 mb-3">
            <Switch
              value={fields.showEbpCode}
              name={"showEbpCode"}
              onChange={handleChange}
              checked={fields.showEbpCode}
            />

            <span className="switch-title-text ml-2 fw-400 f-16 ">
              Show EBP Codes
            </span>
          </div>

          <div className="col-md-6 col-lg-6 col-6 mb-3">
            <Switch
              value={fields.bypassCompliance}
              name={"bypassCompliance"}
              onChange={handleChange}
              checked={fields.bypassCompliance}
            />

            <span className="switch-title-text ml-2 fw-400 f-16 ">
              Bypass Compliance
            </span>
          </div>

        </div>

        <div className="preview-btn-bottom">

          <div className="d-flex my-3">
            <div>
              <button
                onClick={handleSubmit}
                className="green-btn btn-primary border-0 mx-3 btn-space"
              >
                Update
              </button>
            </div>
            <div>
              <button className="btn grey-secondary btn-space" onClick={onClose}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
     
      {showConfirmationDialog && (
        <Dialog
        className="small-dailog"
        onClose={handleCloseConfirmationDialog} title="Confirm Removal For Staff Signature">
        <p
          style={{
            margin: "25px",
          }}
        >
          You have chosen to remove the staff signature section from this document template. Are you sure you want to proceed?
        </p>
        <DialogActionsBar>
        
           <div className="d-flex align-items-stretch w-100">
           <button
              className="green-btn btn-primary border-0 mx-3 btn-space"
              onClick={handleYesOperation}
            >
              Yes
            </button>
         
          <button
            className="btn grey-secondary btn-space"
            onClick={handleCloseConfirmationDialog}
          >
           No
          </button>
           </div>
  
        </DialogActionsBar>
      </Dialog>
      )}


            </Dialog>
        </div>
    );
};
export default TemplateSettings;